import { render, staticRenderFns } from "./purchaseError.vue?vue&type=template&id=873569f8&scoped=true"
import script from "./purchaseError.vue?vue&type=script&lang=js"
export * from "./purchaseError.vue?vue&type=script&lang=js"
import style0 from "./purchaseError.vue?vue&type=style&index=0&id=873569f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873569f8",
  null
  
)

export default component.exports